import { disableLoader, enableLoader, updateStoresList } from '@context/actions';
import { getStoresByTenantIdMysql } from '@storeData/store';
import { navigateTo } from '@util/routerService';
import { formatTimeTo12Hr } from '@util/utils';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import StoreTimings from './storeTimings';

import {
  CaretDownIcon,
  FaPhoneSolid,
  FacebookIcon,
  FbMessengerIcon,
  FcGoogle,
  FloatingWhatsapp,
  ImLocation,
  InstagramIcon,
  MdEmail,
  SnapchatBrandIcon,
  TikTokIcon,
  WhatsappIcon,
  YoutubeIcon
} from '@element/icons';

function Footer() {
    const storeMetaData = useSelector((state: any) => state.store ? state.store.storeMetaData : null);
    const storeData = useSelector((state: any) => state.store ? state.store.storeData : null);
    const store = useSelector((state: any) => state);
    const [socialLinks, setSocialLinks] = useState([]);
    const dispatch = useDispatch();
    const [storesList, setStoresList] = useState([])
    const baseRouteUrl = useSelector((state: any) => state.store.baseRouteUrl);
    const { configData } = useSelector((state: any) => state.store ? state.store.storeData : null);
    const [whatsappLinkData, setWhatsappLinkData] = useState(null);
    const cartAppointment = useSelector((state: any) => state.appointmentServices);
    const currentPage = useSelector((state: any) => state.currentPage);
    const basicConfig = configData?.storeConfig?.basicConfig
    const [timingModal, setTimingModal] = useState(false)
    const languageData: any = store.languageKeywords
    useEffect(() => {
        const { configData: { socialLinks } } = storeData;
        if (socialLinks.length != 0) {
            const linksList: any[] = socialLinks.filter((l: any) => l.active);
            let whatsappIndex = linksList.findIndex((l: any) => l.name.includes('whatsapp'));
            if (whatsappIndex != -1) {
                setWhatsappLinkData(linksList[whatsappIndex]);
                linksList.splice(whatsappIndex, 1)
            }
            setSocialLinks(linksList);
        }
    }, [storeData])

    useEffect(() => {
        if (storeData.tenantId && storesList.length == 0) {
            dispatch(enableLoader());
            getStoresByTenantIdMysql(storeData.tenantId).then((res: any) => {
                dispatch(disableLoader());
                dispatch(updateStoresList(res))
                setStoresList(res);
            }).catch((err) => {
                dispatch(disableLoader());
                console.error(err)
            })
        }
    }, [storeData])

    const toggletimingModal = () => {
        setTimingModal(!timingModal)
    }

    const onClickType = (type: any, data: any = {}) => {
        switch (type) {
            case 'facebook': case 'whatsapp': case 'instagram': case 'youtube': case 'google': case 'snapchat': case 'tiktok': case 'fbmessenger':
                window.open(data.url, '_blank')
                break;
            case 'phone':
                window.open(`tel:${storeMetaData.phone?.length == 10 ? `+${storeMetaData.countryCode} ` : ''}${storeMetaData.phone}`, '_self')
                break;
            case 'location':
                window.open(`${storeMetaData.googleMapUrl ? storeMetaData.googleMapUrl : `https://www.google.com/maps/search/?api=1&query=${storeMetaData.latitude},${storeMetaData.longitude}`}`, '_blank')
                break;
            case 'email':
                window.open(`mailto:${storeMetaData.email}`, '_self')
                break;
            default:
                break;
        }
    }
    return (
        <>
            {storeMetaData?.name?.length != 0 ? <div>
                < div className="footer-wrap" id="footer-wrapper"
                // style={{ backgroundImage: `url(/assets/${genericImages?.footerBg})` }} 
                >
                    <div className="social-wrap">
                        <div className="getInTouch">{languageData["Get In Touch"] ? languageData["Get In Touch"] : "Get In Touch"}</div>
                        <div className="social-icon-wrap">
                            {socialLinks.length !== 0 && socialLinks.map((linkData, index) => {
                                return <div className={`social-icon glass-card`} key={index} onClick={() => onClickType(linkData.name, linkData)}>
                                    {linkData.name.includes('instagram') && <InstagramIcon className="insta" />}
                                    {linkData.name.includes('snapchat') && <SnapchatBrandIcon className="insta" />}
                                    {linkData.name.includes('tiktok') && <TikTokIcon className="insta" />}
                                    {linkData.name.includes('fbmessenger') && <FbMessengerIcon className="insta" />}
                                    {linkData.name.includes('google') && <FcGoogle />}
                                    {linkData.name.includes('facebook') && <FacebookIcon />}
                                    {linkData.name.includes('whatsapp') && <WhatsappIcon />}
                                    {linkData.name.includes('youtube') && <YoutubeIcon />}
                                </div>
                            })}
                        </div>
                        {Boolean(whatsappLinkData) &&
                            <div className={`social-icon glass-card floating-whatsapp`} style={{
                                bottom: (configData.storeConfig?.appointmentConfig?.active && cartAppointment?.length != 0 && currentPage != 'cart' && currentPage != 'checkout' && currentPage != 'appointment') ? "45px" : "0",
                                left: (configData.storeConfig?.appointmentConfig?.active && cartAppointment?.length != 0 && currentPage != 'cart' && currentPage != 'checkout' && currentPage != 'appointment') ? "48%" : "46%"
                            }} >
                                <div onClick={() => onClickType(whatsappLinkData.name, whatsappLinkData)}>
                                    <FloatingWhatsapp />
                                </div>
                            </div>}
                    </div>
                    <div className="information-wrap">
                        <div className="icon glass-card" onClick={() => onClickType('location')}>
                            <ImLocation />
                        </div>
                        {storesList && configData.showStoreLocator && storesList.length > 1 ?
                            <span className="containt">
                                {storesList && storesList.length != 0 && storesList.map((storeData: any, i: number) => {
                                    return <div key={i} className='name' onClick={() => navigateTo('storelocator')}>{storeData.name}</div>
                                })}
                            </span> :
                            <span className="containt" style={{ textTransform: 'capitalize' }}>
                                <a href={storeMetaData.googleMapUrl} rel="noreferrer" target="_blank">
                                    {storeMetaData.address}, {storeMetaData.area}, {storeMetaData.city}, {storeMetaData.state}, {storeMetaData.pincode}
                                </a>
                            </span>
                        }
                    </div>
                    {(Boolean(storeMetaData.phone) || Boolean(storeMetaData.phone1)) && <div className="information-wrap">
                        <div className="icon glass-card" onClick={() => onClickType('phone')}>
                            <FaPhoneSolid />
                        </div>
                        {/* <span className="containt">
                            {storeMetaData.phone && <a href={`tel:${storeMetaData.phone?.length == 10 ? `+${storeMetaData.countryCode} ` : ''}${storeMetaData.phone}`}>
                                {storeMetaData.phone?.length == 10 ? `+${storeMetaData.countryCode} ` : <>&nbsp;&nbsp;&nbsp;</>}{storeMetaData.phone}
                            </a>}
                            {storeMetaData.phone1 && <><br /><a style={{ paddingLeft: '10px' }} href={`tel:+${storeMetaData.countryCode} ${storeMetaData.phone1}`}> +{storeMetaData.countryCode} {storeMetaData.phone1}</a></>}
                        </span>

                        <span className="containt">
                            {storeMetaData.phone && <a href={`tel:${storeMetaData.phone?.length == 10 ? `${basicConfig.multipleCountryCode ? "+" + storeMetaData.countryCode : ""} ` : ''}${storeMetaData.phone}`}>
                                {storeMetaData.phone?.length == 10 ? `${basicConfig.multipleCountryCode ? "+" + storeMetaData.countryCode : ""} ` : <>&nbsp;&nbsp;&nbsp;</>}{storeMetaData.phone}
                            </a>}
                            {storeMetaData.phone1 && <><br /><a style={{ paddingLeft: '10px' }} href={`tel:${basicConfig.multipleCountryCode ? "+" + storeMetaData.countryCode : ""} ${storeMetaData.phone1}`}></a></>}
                        </span> */}
                        <span className="containt">
                            {storeMetaData.phone && (
                                <a href={`tel:${storeMetaData.phone?.length == 10 ? `${basicConfig.multipleCountryCode ? "+" + storeMetaData.countryCode : ""} ` : ''}${storeMetaData.phone}`}>
                                    {storeMetaData.phone?.length == 10
                                        ? `${basicConfig.multipleCountryCode ? "+" + storeMetaData.countryCode : ""} `
                                        : <>&nbsp;&nbsp;&nbsp;</>
                                    }
                                    {storeMetaData.phone}
                                </a>
                            )}
                            {/* {storeMetaData.phone && <a href={`tel:${storeMetaData.phone}`}>{storeMetaData.phone}</a>} */}
                            {storeMetaData.phone1 &&
                                <>
                                    <br />
                                    <a style={{ paddingLeft: '10px' }} href={`tel:${basicConfig.multipleCountryCode ? "+" + storeMetaData.countryCode : ""} ${storeMetaData.phone1}`}>
                                        {basicConfig.multipleCountryCode ? "+" + storeMetaData.countryCode : ""} {storeMetaData.phone1}
                                    </a>
                                </>
                            }
                        </span>
                    </div>}

                    {Boolean(storeMetaData.email) && <div className="information-wrap">
                        <div className="icon glass-card" onClick={() => onClickType('email')}>
                            <MdEmail />
                        </div>
                        <span className="containt"> <a href={`mailto:${storeMetaData.email}`} rel="noreferrer" target="_blank">{storeMetaData.email}</a></span>
                    </div>}
                    {Boolean(storeData?.configData?.dayWiseTiming) && <div className="store-timing-wrap glass-card">
                        <><div className='sub-heading' onClick={toggletimingModal}>*{languageData["Working Hours"] ? languageData["Working Hours"] : "Working Hours"} : {formatTimeTo12Hr(storeData.configData?.dayWiseTiming[(new Date()).getDay()].startTime)} to {formatTimeTo12Hr(storeData.configData?.dayWiseTiming[(new Date()).getDay()].closureTime)}   <CaretDownIcon /></div></>
                    </div>}
                    <div className="copyright-wrp" style={{ textTransform: 'capitalize' }}>
                        <span>Copyright &copy; {new Date().getFullYear()} {storeData.tenant}, {storeMetaData.name}</span>
                    </div>
                </div>
            </div > : null
            }
            <StoreTimings openModal={timingModal} handleClose={toggletimingModal}></StoreTimings>
        </>
    )
}

export default Footer
